const FormWidgetSplitConfig = {
  componentType: 'FORM_WIDGET_SPLIT',
  widgetConfig: {
    icon: 'x-lib-split',
    text: '分隔符',
    description: '通过分割线分隔页面内容'
  },
  componentConfig: {
    uuid: `32bit uuid`,
    width: 12,
    height: 1,
    textColor: '#B2B2B2',
    lengthLimit: 200,
    render: {
      ide: 'FormWidgetSplit',
      edit: 'FormWidgetSplit',
      read: 'FormWidgetSplit'
    }
  },
  editorConfig: ['INFO', 'SPLIT_DEFAULT', 'SPLIT_COLOR', 'HIDDEN']
}

export default FormWidgetSplitConfig
